import { Component, Input } from '@angular/core';

export enum TopgolfAnimationState {
	LOADING = 'loading',
	SUCCESS = 'success',
	FAILED = 'failed',
}

@Component({
	selector: 'app-topgolf-animation',
	standalone: false,
	templateUrl: './topgolf-animation.component.html',
	styleUrls: ['./topgolf-animation.component.scss'],
})
export class TopgolfAnimationComponent {
	@Input() state: TopgolfAnimationState = TopgolfAnimationState.LOADING;
	@Input() message: string = '';
	@Input() orderId: string = '';

	get isLoading(): boolean {
		return this.state === TopgolfAnimationState.LOADING;
	}

	get isSuccess(): boolean {
		return this.state === TopgolfAnimationState.SUCCESS;
	}

	get isFailed(): boolean {
		return this.state === TopgolfAnimationState.FAILED;
	}

	setState(state: TopgolfAnimationState) {
		this.state = state;
	}

	setMessage(msg: string) {
		this.message = msg;
	}
}
